import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";
import Skeleton from "../pages/Skeleton";
import { PostMoreFetchData } from "../../redux/actions/PostMoreAction";
import RelatedGalleryItem from "./RelatedGalleryItem";

const GalleryMorePage = ({
  innerData,
  isScrollUpdate
}) => {
  const postMoreData = useSelector((state) => state?.PostMoreReducer?.data);
  const loadingPostMore = useSelector(
    (state) => state?.PostMoreReducer?.loading
  );

  const [relatedPostsList, setRelatedPostsList] = useState([]);
  const [relatedReadMore, setRelatedReadMore] = useState({});
  const relatedPostsRef = useRef([]);

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(PostMoreFetchData(innerData?.url));
  }, [innerData?.url])

  useEffect(() => {
    if (innerData?.id) {
      setRelatedPostsList([]);
      setRelatedReadMore({});
    }
  }, [innerData?.id]);

  useEffect(() => {
    if (loadingPostMore) return;
    const rawData = postMoreData?.data || postMoreData;
    const rPosts = rawData?.relatedPosts;
    if (rPosts && Array.isArray(rPosts)) {
      setRelatedPostsList(rPosts);
    }
  }, [postMoreData, loadingPostMore]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const url = entry.target.getAttribute("data-url");
            if (url) {
              const newPath = "/" + url;
              if (isScrollUpdate) {
                isScrollUpdate.current = newPath;
              }
              // We don't forcefully overwrite query param state if it exists, but 
              // for simplicity let RelatedGalleryItem image observers handle the exact URL ?id
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    relatedPostsRef.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      if (relatedPostsRef.current) {
        relatedPostsRef.current.forEach((el) => {
          if (el) observer.unobserve(el);
        });
      }
    };
  }, [relatedPostsList, isScrollUpdate]);

  // const handleRelatedReadMore = (id) => {
  //   setRelatedReadMore((prev) => ({ ...prev, [id]: true }));
  //    ReactGA.send({
  //           hitType: "pageview",
  //           page: window.location.pathname,
  //           title: "PostShare",
  //         });

  //    window._comscore = window._comscore || [];
  //           window._comscore.push({
  //             c1: "2",
  //             c2: "38736750",
  //             page: `${window.location.pathname}-relatedPost${id}`,
  //           });

  //           if (window.COMSCORE && window.COMSCORE.beacon) {
  //             window.COMSCORE.beacon({
  //               c1: "2",
  //               c2: "38736750",
  //               page: `${window.location.pathname}-relatedPost${id}`,
  //             });
  //           }
  // };

  return (
    <>
      <div className="post-more-section">
        {relatedPostsList.length > 0 &&
          relatedPostsList.map((relatedPost, index) => {
            const isExpanded = relatedReadMore[relatedPost.id];

            return (
              <React.Fragment key={relatedPost.id}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "40px 0",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      height: "2px",
                      background:
                        "linear-gradient(to right, transparent, #ae0a0b)",
                    }}
                  ></div>

                  <div
                    style={{
                      padding: "0 20px",
                      color: "#1a1a1a",
                      fontWeight: "700",
                      fontSize: "20px",
                      whiteSpace: "nowrap",
                      fontFamily: "inherit",
                    }}
                  >
                    આ પણ વાંચો
                  </div>

                  <div
                    style={{
                      flex: 1,
                      height: "2px",
                      background:
                        "linear-gradient(to left, transparent, #ae0a0b)",
                    }}
                  ></div>
                </div>

                <RelatedGalleryItem
                  ref={(el) => (relatedPostsRef.current[index] = el)}
                  data={relatedPost}
                  isExpanded={isExpanded}
                />
              </React.Fragment>
            );
          })}
        <div
          className="text-center py-4"
          style={{ minHeight: "60px", display: relatedPostsList.length > 0 ? "none" : "block" }}
        >
          {loadingPostMore ? <Skeleton height={100} /> : null}
        </div>
      </div>
    </>
  );
};

export default GalleryMorePage;
